import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";

import "react-data-table-component-extensions/dist/index.css";
import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";
import axios from "../api/axios";
import {  Apitoken, Authtoken } from "../Global";
import {MaterialReactTable} from 'material-react-table';
import FindModuleById from '.././FindModuleById';
// import { toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
import { MenuItem} from '@mui/material';
import Swal from 'sweetalert2';

const EditInvoicingPayment = () => {
  const [menu, setMenu] = useState(false);
  const [data, setData] = useState([]);
  const [value, setValue] = useState({});
    const [permission, setPermission] = useState({});

useEffect(() => {
  setPermission(FindModuleById(181));
}, []);

//  const [currencySymbol, setCurrencySymbol] = useState('');
  let { id } = useParams();
   let season_id = localStorage.getItem("season_id");



  useEffect(() => {
    axios
      .get(`/invoices/view-download/${season_id+'-'+id}`, {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      })
      .then((response) => {
        console.log(response);

        if (response.data.code === 200) {
          setValue(response.data.data.invoice);
          axios.get(`/invoices/payments/${season_id+'-'+id}`, {
            headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
          })
          .then((response) => {
            if (response.data.code === 200) {
              setData(response.data.data.payments);
            }
          })
          .catch((error) => {
            console.log(error);
          });
        }
      })
      .catch((error) => {
        console.log(error);
      });

  }, [id]);

  // useEffect(() => {
  //   axios
  //     .post(
  //       "/invoices/listing",
  //       para,
  //       {
  //         headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
  //       }
  //     )
  //     .then((response) => {
  //       if (response.data.code === 200) {
  //         setData(response.data.data.invoices);
  //       }
  //     })
  //     .catch((error) => {
  //       console.log(error);
  //     });
  // }, []);

  const toggleMobileMenu = () => {
    setMenu(!menu);
  };


  const columns = [
    {
      accessorKey: 'opearation_type',
      header: 'Operation Type',
    },
    {
      accessorKey: 'payment_date',
      header: 'Payment Date',
    },

    {
      // accessorKey: 'payment_amount',
      header: 'Payment Amount',
      accessorFn: (row) =>`${parseFloat(row.payment_amount).toFixed(2)} €`,
    },
    {
      accessorKey: 'exchange_date',
      header: 'Exchange Date',
    },
    {
      accessorKey: 'exchange_rate',
      header: 'Exchange Rate',
    },
    {
      header: 'Amount',
      accessorFn: (row) =>`${parseFloat(row.amount).toFixed(2)} MAD`,
    },
       {
      header: 'Created By',
      accessorFn: (row) =>
        row.createdby ? `${row.createdby.first_name} ${row.createdby.last_name}` : '',
    },
    {
      header: 'Updated By',
      accessorFn: (row) =>
        row.updatedby ? `${row.updatedby.first_name} ${row.updatedby.last_name}` : '',
    },
  ];

  const deleteItem = (item) => {
      let season_id = localStorage.getItem("season_id");

    Swal.fire({
      title: 'Do you really want to delete this record?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'DELETE'
    }).then((result) => {
      if (result.isConfirmed) {
        axios.get(`/invoices/payments/delete/${season_id+'-'+item}`, {
              headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
            })
            .then((response) => {
              console.log(response);
              if (response.data.code === 200) {
                Swal.fire(
                  'Deleted!',
                  'Your Record has been deleted.',
                  'success'
                );
                 
                 axios
                  .get(`/invoices/view-download/${season_id+'-'+id}`, {
                    headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
                  })
                  .then((response) => {
                    console.log(response);

                    if (response.data.code === 200) {
                      setValue(response.data.data.invoice);
                      axios.get(`/invoices/payments/${season_id+'-'+id}`, {
                        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
                      })
                      .then((response) => {
                        if (response.data.code === 200) {
                          setData(response.data.data.payments);
                        }
                      })
                      .catch((error) => {
                        console.log(error);
                      });
                    }
                  })
                  .catch((error) => {
                    console.log(error);
                  });
              }
            })
            .catch((error) => {
              console.log(error);
            });
      }
    });
  }
  const editItem = (item)=>{
     window.location.href = "/invoices-payment-edit/"+item.id;
  }
	
  return (
    <>
      <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
        <Header onMenuClick={() => toggleMobileMenu()} />
        <Sidebar />

        <div className="page-wrapper">
          {permission?.list == 1 && (
          <div className="content container-fluid">
          
            <div className="page-header">
              <div className="row align-items-center">
                <div className="col">
                  <h3 className="page-title">Invoice Payment</h3>
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/profile">Profile</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to="/invoices">Invoices</Link>
                    </li>
                    <li className="breadcrumb-item active">Invoice Payment</li>
                  </ul>
                </div>
               
              </div>
            </div>
            <div className="row">
              <div className="col-sm-12">
              <div className="card customer-details-group">
                <div className="card-body">
                  <div className="row align-items-center">
                    
                    <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                      <div className="customer-details">
                        <div className="d-flex align-items-center"><span className="customer-widget-icon d-inline-flex"><i className="fe fe-mail">
                          </i></span>
                          <div className="customer-details-cont">
                            <h6>Invoice Number</h6>
                            <p>{value.invoice_number}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                      <div className="customer-details">
                        <div className="d-flex align-items-center"><span className="customer-widget-icon d-inline-flex"><i className="fe fe-airplay">
                          </i></span>
                          <div className="customer-details-cont">
                            <h6>Customer Name</h6>
                            <p> {value.customer_id
                                ? value.customer.company_name
                                : ""}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                      <div className="customer-details">
                        <div className="d-flex align-items-center"><span className="customer-widget-icon d-inline-flex"><i className="fe fe-phone">
                          
                          </i></span>
                          <div className="customer-details-cont">
                            <h6>Total Amount</h6>
                            <p>{parseFloat(value.total_amount).toFixed(2)}{value.customer?.currency?.symbol}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  
                    <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                      <div className="customer-details">
                        <div className="d-flex align-items-center"><span className="customer-widget-icon d-inline-flex"><i className="fe fe-globe">
                          </i></span>
                          <div className="customer-details-cont">
                            <h6>Payment Terms</h6>
                            <p> {value.customer && value.customer.payment_terms
                                ? value.customer.payment_terms
                                    .name
                                : ""}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                    
                  </div>
                </div>
              </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-12 push-right pull-right">
                <div className="col-auto pull-right">
                    <Link to={`/invoices-payment-add/${id}`} className="btn btn-primary me-1">
                      <i className="fas fa-plus"></i> Add Invoice Payment
                    </Link>
                 
                  </div>
              </div>
            </div>
            <br/>

            <div className="row">
              <div className="col-sm-12">
                <div className="card card-table">
                  <div className="card-body">
                    <div className="table-responsive">
                    <MaterialReactTable columns={columns} data={data} 
                      enableColumnOrdering
                      enablePinning
                      enableRowActions
                      renderColumnActionsMenuItems 
                       renderRowActionMenuItems={({ row }) => [
                            permission?.update === 1  && (
                              <MenuItem key="edit" onClick={() => editItem(row.original)}>
                                Edit
                              </MenuItem>
                            ),
                           
                            permission?.delete == 1 && (
                              <MenuItem key="delete" onClick={() => deleteItem(row.original.id)}>
                                Delete
                              </MenuItem>
                            ),
                          ]}
                    />
                    </div>
                  </div>
                </div>
              </div>
            </div>
           
          </div>
           )} 
        </div>
      </div>
    </>
  );
};
export default EditInvoicingPayment;
